// extracted by mini-css-extract-plugin
export default {"status_container":"MicroFeServiceConfiguration_status_container__ZMGVc","status":"MicroFeServiceConfiguration_status__l-I0R"};